import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandAccountsListPage_UpdateBrandAccount(
    $input: UpdateBrandAccountInput!
  ) {
    updateBrandAccount(input: $input) {
      id
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useUpdateBrandAccountMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables['input'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (input) => graphQLRequest({ document, variables: { input } }),
    ...options,
  })
}
